import { useI18n } from '../i18n';
import { Button } from '../components/Button';
import { useWaitlist } from '../components/WaitlistProvider';
import styles from './FinalCta.module.css';

/**
 * The closing panel: cocoa filling the frame, which is what the brand spec
 * reserves it for — a full-bleed brand surface with no product on screen.
 */
export function FinalCta() {
  const { t } = useI18n();
  const { open } = useWaitlist();

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>{t.finalCta.heading}</h2>
      <p className={styles.body}>{t.finalCta.body}</p>
      <div className={styles.ctas}>
        <Button variant="onCocoa" size="lg" onClick={() => open('final-cta-ios')}>
          {t.store.ios}
        </Button>
        <Button variant="outlineOnCocoa" size="lg" onClick={() => open('final-cta-android')}>
          {t.store.android}
        </Button>
      </div>
    </section>
  );
}
